import { createActions } from 'redux-actions';

import types from 'state/order/actionTypes';

const { order } = createActions({
  [types.setTypeOrder$]: ({ type }) => ({
    type,
  }),
  [types.SET_TYPE]: ({ type }) => ({ type }),
  [types.SET_RECURRING]: ({ isRecurring }) => ({ isRecurring }),

  [types.SET_MAX_ITEMS_IN_LOAD]: (max = undefined) => ({ max }),
  [types.SET_HOLIDAYS]: ({ holidays, stopType, shipmentKey }) => ({
    holidays,
    stopType,
    shipmentKey,
  }),
  [types.SET_QUOTE_SUGGESTIONS]: ({ quoteSuggestions }) => ({
    quoteSuggestions,
  }),
  [types.CLEAN_QUOTE_SUGGESTIONS]: () => ({}),
  [types.SET_VALIDATIONS]: ({ validations }) => ({
    validations,
  }),
  [types.SET_SHIPPER_QUOTE_ID]: ({ shipperQuoteId }) => ({
    shipperQuoteId,
  }),
  [types.fetchQuote$]: () => ({}),
  [types.quoteNotification$]: () => ({}),
  [types.submitQuote$]: () => ({}),
  [types.confirmOrder$]: () => ({}),
  [types.payOrder$]: ({ token, cif, paymentIntent }) => ({
    token,
    cif,
    paymentIntent,
  }),
  [types.submitOrder$]: ({
    acceptedTerms,
    commercialCommunications,
    needsLegalAuth,
  }) => ({
    acceptedTerms,
    commercialCommunications,
    needsLegalAuth,
  }),
  [types.submitEditOrder$]: ({
    acceptedTerms,
    commercialCommunications,
    needsLegalAuth,
  }) => ({
    acceptedTerms,
    commercialCommunications,
    needsLegalAuth,
  }),
  [types.submitNonCoreOrder$]: ({
    acceptedTerms,
    commercialCommunications,
    needsLegalAuth,
  }) => ({
    acceptedTerms,
    commercialCommunications,
    needsLegalAuth,
  }),
  [types.discardEdition$]: () => ({}),
  [types.SET_MAX_REACHED]: (reached) => ({ reached }),
  [types.SET_MAXIMUMS]: ({ maximums }) => ({
    maximums,
  }),
  [types.setExtra$]: (extra) => ({
    extra,
  }),
  [types.setAditionalOption$]: ({ type, shipmentKey, stopType, value }) => ({
    type,
    shipmentKey,
    stopType,
    value,
  }),
  [types.checkAditionalOption$]: ({ type, stopType, shipmentKey, value }) => ({
    type,
    stopType,
    shipmentKey,
    value,
  }),
  [types.setDefaults$]: () => ({}),
  [types.navigateToForm$]: () => ({}),
  [types.discardOrder$]: () => ({}),
  [types.repeatOrder$]: ({ originalOrder, place }) => ({
    originalOrder,
    place,
  }),
  [types.prefillSuggestedOrder$]: ({ type }) => ({ type }),
  [types.setRange$]: ({ type, value }) => ({ type, value }),
  [types.setDay$]: ({ day }) => ({ day }),
  [types.fetchHolidays$]: () => ({}),
  [types.startOrderWithAddress$]: ({ address }) => ({ address }),
  [types.checkPaymentMethod$]: () => ({}),

  [types.SET_PAYMENT_INTENT_SECRET]: ({ paymentIntentSecret }) => ({
    paymentIntentSecret,
  }),
  [types.SET_LAST_ID]: ({ lastId }) => ({ lastId }),

  [types.editOrder$]: ({ originalOrder }) => ({ originalOrder }),
  [types.SET_EDITING]: ({
    isEditing,
    type,
    originalPrice = {},
    originalId,
  }) => ({
    isEditing,
    type,
    originalPrice,
    originalId,
  }),

  [types.cleanRepeatAndEditing$]: () => ({}),
  [types.applyHolidays$]: ({ address, stopType, shipmentKey }) => ({
    address,
    stopType,
    shipmentKey,
  }),
  [types.getValidations$]: () => ({}),
  [types.watchForShipperQuoteId$]: ({ shipmentKey, loadKey }) => ({
    shipmentKey,
    loadKey,
  }),
  [types.fetchTimeWindows$]: () => ({}),
  [types.disableEconomyMode$]: () => ({}),
  [types.enableEconomyMode$]: () => ({}),
  [types.SET_TIME_WINDOWS]: ({ timeWindows }) => ({ timeWindows }),
  [types.CLEAN_TIME_WINDOWS]: () => ({}),
  [types.SET_TIME_WINDOWS_REQUEST_PAYLOAD]: ({
    timeWindowsRequestPayload,
  }) => ({ timeWindowsRequestPayload }),
});

export default order;
